module.exports = __webpack_public_path__ + "img/Axima_logo-194x80.65751394.png";